import { isSamePlatformId } from '@app/modules/social-export/domain/is-same-platform-id';
import { SocialPlatform, socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { useMemo } from 'react';
import { useStationConnections } from './useStationConnections';

export interface AvailableSocialExportPlatformsResult {
  readonly platforms: SocialPlatform[];
  /**
   * False until {@link stationId} is known and the by-station connections request has settled.
   * Used to avoid treating an empty connection list as "no platforms" before the response arrives.
   */
  readonly areConnectionsResolved: boolean;
}

/**
 * Platforms for a station that have at least one social connection
 * (fragment and composition publish).
 */
export function useAvailableSocialExportPlatformsForStation(
  stationId: string | undefined,
): AvailableSocialExportPlatformsResult {
  const { connections, areConnectionsResolved } = useStationConnections(stationId);

  const availablePlatforms = useMemo(() => {
    const platforms = socialPlatforms.all();
    return platforms.filter((platform) =>
      connections.some((r) => isSamePlatformId(r.platform, platform.id)),
    );
  }, [connections]);

  return { platforms: availablePlatforms, areConnectionsResolved };
}
